import { inject, Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoService } from '@jsverse/transloco';
import { distinctUntilChanged } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MatLanguagePaginatorIntl extends MatPaginatorIntl {
  #translocoService = inject(TranslocoService);

  constructor() {
    super();
    this.#translocoService.langChanges$.pipe(distinctUntilChanged()).subscribe((lang) => {
      this.setTranslations();
      this.changes.next();
    });
  }

  setTranslations() {
    this.itemsPerPageLabel = this.#translocoService.translate('common.paginator.itemsPerPage');
    const ofLabel = this.#translocoService.translate('common.of');
    this.getRangeLabel = (page: number, pageSize: number, length: number) => {
      if (length === 0 || pageSize === 0) {
          return '0 ' + ofLabel + ' ' + length;
      }
      length = Math.max(length, 0);
      const startIndex = page * pageSize;
      // If the start index exceeds the list length, do not try and fix the end index to the end.
      const endIndex =
          startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
      return startIndex + 1 + ' - ' + endIndex + ' ' + ofLabel + ' ' + length;
  };
  }




}
